export const elasticsearchConfigSnippet =
`# Enables/disables the Elasticsearch module for transaction logging. If omitted the default value is true.
nca.ds:
   elasticsearch.transaction.logging.enabled: true
# Following properties must be set in order to establish the connection with Elasticsearch:
spring:
   elasticsearch:
     uris: https://host:port           # Comma-separated list of the Elasticsearch instances to use.
     username: elastisearch.username   # Username for authentication with Elasticsearch. 
     password: elastisearch.password   # Password for authentication with Elasticsearch.
#
# Following properties are also available for configuration. Should be configured only when there is need to 
# override the default value given below.
# 
# Whether to enable Elasticsearch repositories.
#spring.data.elasticsearch.repositories.enabled=true
# Connection timeout used when communicating with Elasticsearch.
#spring.elasticsearch.connection-timeout=1s
# Prefix added to the path of every request sent to Elasticsearch.
#spring.elasticsearch.path-prefix
# Delay of a sniff execution scheduled after a failure.
#spring.elasticsearch.restclient.sniffer.delay-after-failure=1m
# Interval between consecutive ordinary sniff executions.
#spring.elasticsearch.restclient.sniffer.interval=5m
# Whether to enable socket keep alive between client and Elasticsearch.
#spring.elasticsearch.socket-keep-alive=false
# Socket timeout used when communicating with Elasticsearch.
#spring.elasticsearch.socket-timeout=30s
    `

export const elasticsearchIndexNameSnippet =
   'nca.ds.elasticsearch.transaction.logging.index-name: "ds_transaction_log"'

